import { CSSObject } from '@chakra-ui/react';
import featureDesktop from '@/assets/bet777/images/homeFeaturedSport/featSport.jpg';
import featuredMb from '@/assets/bet777/images/homeFeaturedSport/featSportMb.png';

export const FlexMiscWrapper: CSSObject = {
  py: 2,
};

export const FlexWrapper: CSSObject = {
  h: ['280px', '215px'],
  border: 'none',
  bgImage: [`url(${featuredMb})`, `url(${featureDesktop})`],
  bgPos: 'bottom',
  bgRepeat: 'no-repeat',
  bgSize: 'cover',
  alignItems: 'center',
  justifyContent: 'center',
  transformStyle: 'preserve-3d',
  pos: 'relative',
  contain: 'paint',
  my: ['1', null, '0'],
  mx: '0',
  pt: ['1', '5'],
  pl: '0',
  flexDir: ['column', 'row'],
  borderRadius: 'md',
  boxShadow:
    '0px 4px 10px 0px rgba(0, 0, 0, 0.30), 0px 0px 0px 1px rgba(255, 255, 255, 0.12) inset',
  backdropFilter: 'blur(2.5px)',
};

export const FlexFeatureCardWrapper: CSSObject = {
  w: 'full',
  flexDir: 'column',
  justifyContent: 'center',
  alignItems: 'center',
};

export const FlexTeamWrapper: CSSObject = {
  flexDir: ['column', 'row'],
  gap: ['1', '3'],
  maxW: '450px',
  mb: '3',
  mt: '2',
};

export const FlexTextWrapper: CSSObject = {
  width: ['unset', '60%'],
};

export const TextVS: CSSObject = {
  bg: 'transparent',
  color: 'gamma.400',
  fontSize: 'md',
  fontWeight: 'normal',
  borderRadius: 'md',
  border: '2px solid',
  borderColor: 'gamma.400',
  fontFamily: 'heading',
  boxShadow: 'unset',
};

export const TextMisc: CSSObject = {
  borderRadius: 'md',
  color: 'beta.800',
  textShadow: 'none',
  fontSize: 'xs',
  fontWeight: 'extrabold',

  bg: 'beta.400',
  boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.30)',
  '& span': {
    color: 'rgba(0, 0, 0, 0.36)',
  },
};

export const TextTeam: CSSObject = {
  color: 'white',
  fontSize: 'xl',
  fontWeight: 'normal',
  fontFamily: 'heading',
  lineHeight: 'normal',
};

export const BoxHeadingWrapper: CSSObject = {
  fontFamily: 'heading',
  fontSize: '3xl',
  fontWeight: 'normal',
  textShadow: '0px 4px 6px rgba(0, 0, 0, 0.20)',
  color: 'gamma.400',
};

export const puntButtonProps: CSSObject = {
  borderRadius: 'base',
  color: 'alpha.700',
  fontWeight: 'normal',
  h: '9',
  bgGradient: 'linear(to-b, gamma.300, gamma.500)',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.35)',
  lineHeight: 'normal',
  boxShadow:
    '0px 3px 5px 0px rgba(0, 0, 0, 0.30), 0px 0px 0px 1px rgba(255, 255, 255, 0.15) inset',
  _hover: {
    bgGradient: 'linear(to-b, gamma.200, gamma.200)',
  },
};
